/* CŒURA moon — date → phase of the actual sky that night.
   Synodic-month math from the 2000-01-06 18:14 UTC new moon; no dependencies.
   Mockup simulation of the production date→phase→dimensions automation. */

(function () {
  'use strict';

  var SYNODIC = 29.530588853;
  var EPOCH = Date.UTC(2000, 0, 6, 18, 14, 0); // known new moon

  function age(date) {
    var days = (date.getTime() - EPOCH) / 86400000;
    var a = days % SYNODIC;
    if (a < 0) a += SYNODIC;
    return a;
  }

  function phaseName(a) {
    if (a < 1.845) return 'new';
    if (a < 5.53) return 'a waxing crescent';
    if (a < 9.22) return 'in its first quarter';
    if (a < 12.91) return 'a waxing gibbous';
    if (a < 16.61) return 'full';
    if (a < 20.30) return 'a waning gibbous';
    if (a < 23.99) return 'in its last quarter';
    if (a < 27.68) return 'a waning crescent';
    return 'new';
  }

  function words(n) {
    var w = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve'];
    return n <= 12 ? w[n] : String(n);
  }

  /* Lit-region path: circle limb arc + terminator ellipse arc. */
  function litPath(a, cx, cy, r) {
    var p = a / SYNODIC;
    var k = Math.cos(2 * Math.PI * p);       // 1 new → -1 full → 1 new
    var rx = Math.abs(k) * r;
    var top = cx + ' ' + (cy - r), bot = cx + ' ' + (cy + r);
    if (p <= 0.5) { // waxing — lit on the right
      var sweep2 = k > 0 ? 0 : 1;
      return 'M ' + top + ' A ' + r + ' ' + r + ' 0 0 1 ' + bot +
             ' A ' + rx + ' ' + r + ' 0 0 ' + sweep2 + ' ' + top + ' Z';
    }
    var sweep2b = k > 0 ? 1 : 0; // waning — lit on the left
    return 'M ' + top + ' A ' + r + ' ' + r + ' 0 0 0 ' + bot +
           ' A ' + rx + ' ' + r + ' 0 0 ' + sweep2b + ' ' + top + ' Z';
  }

  function svg(date, size, opts) {
    opts = opts || {};
    var s = size || 64, cx = s / 2, cy = s / 2, r = s / 2 - 2;
    var a = age(date);
    var disc = opts.disc || 'rgba(26,26,26,0.92)';
    var lit = opts.lit || '#F5F0E8';
    var body = '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + disc + '"/>';
    if (a >= 1.845 || SYNODIC - a < 1.845) {
      // any visible sliver at all
    }
    body += '<path d="' + litPath(a, cx, cy, r) + '" fill="' + lit + '"/>';
    body += '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="rgba(26,26,26,0.4)" stroke-width="1"/>';
    return '<svg viewBox="0 0 ' + s + ' ' + s + '" width="' + s + '" height="' + s + '" role="img" aria-label="Moon phase">' + body + '</svg>';
  }

  function sentence(date) {
    var a = age(date);
    var name = phaseName(a);
    var d = date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
    var tail;
    if (name === 'full') tail = 'whole above you';
    else if (name === 'new') tail = 'new — a dark sky, holding its breath';
    else {
      var toFull = Math.round(Math.abs(14.765 - a));
      if (toFull === 0) tail = 'all but full';
      else tail = words(toFull) + ' day' + (toFull === 1 ? '' : 's') + (a < 14.765 ? ' from full' : ' past full');
    }
    return 'On the night of ' + d + ', the moon above you was ' + name + ', ' + tail + '.';
  }

  function illumination(date) {
    var p = age(date) / SYNODIC;
    return Math.round((1 - Math.cos(2 * Math.PI * p)) / 2 * 100);
  }

  /* ---- The Moon ordering window (§6) — the one live element in the nav ------
     Anchored to America/Los_Angeles; window opens AT a full moon and runs
     windowLengthDays. No API, just /data/moon-windows.json. */
  var MONTHS = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY',
                'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
  function parseD(s) { var p = s.split('-'); return Date.UTC(+p[0], +p[1] - 1, +p[2]); }
  function fmtDay(ms) { var d = new Date(ms); return d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()]; }
  function laTodayMs() {
    try {
      var s = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles',
        year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      return parseD(s);
    } catch (e) { return parseD(new Date().toISOString().slice(0, 10)); }
  }
  /* window(data[, todayStr]) → { open, line, color } (color is a CSS var name) */
  function moonWindow(data, todayStr) {
    var today = todayStr ? parseD(todayStr) : laTodayMs();
    var len = (data && data.windowLengthDays) || 7;
    var moons = ((data && data.fullMoons) || []).map(parseD).sort(function (a, b) { return a - b; });
    var DAY = 86400000;
    for (var i = 0; i < moons.length; i++) {
      var fm = moons[i], close = fm + len * DAY;
      if (today >= fm && today <= close) {
        return { open: true, line: 'WINDOW OPEN · CLOSES ' + fmtDay(close) + ' · SHIPS BY THE NEXT FULL MOON', color: 'gold-deep' };
      }
    }
    var next = null;
    for (var j = 0; j < moons.length; j++) { if (moons[j] > today) { next = moons[j]; break; } }
    if (next === null) {
      console.warn('[moon] no future full-moon dates in moon-windows.json — extend the file');
      return { open: false, line: 'OPENS AT THE NEXT FULL MOON · SHIPS BY THE ONE AFTER', color: 'gray-deep' };
    }
    return { open: false, line: 'OPENS AT THE FULL MOON · ' + fmtDay(next) + ' · SHIPS BY THE NEXT', color: 'gray-deep' };
  }
  var _mw = null;
  function loadWindow() {
    if (_mw) return Promise.resolve(_mw);
    return fetch('data/moon-windows.json?v=12', { cache: 'no-cache' })
      .then(function (r) { return r.json(); })
      .then(function (d) { _mw = d; return d; })
      .catch(function () { return { windowLengthDays: 7, fullMoons: [] }; });
  }


  /* ---- Moon SIGN -----------------------------------------------------------
     The phase above only needs the Moon's age. A moon sign needs where the Moon actually WAS:
     its apparent ecliptic longitude, which the tropical zodiac divides into twelve 30-degree
     signs starting at the vernal equinox. The Moon covers about 13.2 degrees a day, so it
     changes sign roughly every two and a half days — which is why the date alone is sometimes
     not enough and the hour decides it.

     Truncated ELP2000-82 (Meeus, Astronomical Algorithms ch. 47): the 35 largest periodic terms,
     good to well under a hundredth of a degree — far finer than a sign boundary needs. Standard
     astrological practice is geocentric, so the birthplace is not used for the position itself;
     it is used to know what instant "9pm on the 14th" was, which is the timezone. */

  var RAD = Math.PI / 180;
  /* D, M, M', F, coefficient in millionths of a degree */
  var TERMS = [
    [0,0,1,0,6288774],[2,0,-1,0,1274027],[2,0,0,0,658314],[0,0,2,0,213618],
    [0,1,0,0,-185116],[0,0,0,2,-114332],[2,0,-2,0,58793],[2,-1,-1,0,57066],
    [2,0,1,0,53322],[2,-1,0,0,45758],[0,1,-1,0,-40923],[1,0,0,0,-34720],
    [0,1,1,0,-30383],[2,0,0,-2,15327],[0,0,1,2,-12528],[0,0,1,-2,10980],
    [4,0,-1,0,10675],[0,0,3,0,10034],[4,0,-2,0,8548],[2,1,-1,0,-7888],
    [2,1,0,0,-6766],[1,0,-1,0,-5163],[1,1,0,0,4987],[2,-1,1,0,4036],
    [2,0,2,0,3994],[4,0,0,0,3861],[2,0,-3,0,3665],[0,1,-2,0,-2689],
    [2,0,-1,2,-2602],[2,-1,-2,0,2390],[1,0,1,0,-2348],[2,-2,0,0,2236],
    [0,1,2,0,-2120],[0,2,0,0,-2069],[2,-2,-1,0,2048]
  ];
  function norm360(x) { x = x % 360; return x < 0 ? x + 360 : x; }

  /* apparent geocentric ecliptic longitude of the Moon, in degrees, for a Date */
  function longitude(date) {
    var T = (date.getTime() / 86400000 + 2440587.5 - 2451545) / 36525;
    var T2 = T * T, T3 = T2 * T, T4 = T3 * T;
    var Lp = 218.3164477 + 481267.88123421 * T - 0.0015786 * T2 + T3 / 538841 - T4 / 65194000;
    var D  = 297.8501921 + 445267.1114034 * T - 0.0018819 * T2 + T3 / 545868 - T4 / 113065000;
    var M  = 357.5291092 + 35999.0502909 * T - 0.0001536 * T2 + T3 / 24490000;
    var Mp = 134.9633964 + 477198.8675055 * T + 0.0087414 * T2 + T3 / 69699 - T4 / 14712000;
    var F  = 93.2720950 + 483202.0175233 * T - 0.0036539 * T2 - T3 / 3526000 + T4 / 863310000;
    var E = 1 - 0.002516 * T - 0.0000074 * T2;    // the Sun's terms shrink as its orbit changes
    var sum = 0;
    for (var i = 0; i < TERMS.length; i++) {
      var t = TERMS[i], arg = (t[0] * D + t[1] * M + t[2] * Mp + t[3] * F) * RAD;
      var c = t[4];
      if (t[1] === 1 || t[1] === -1) c *= E;
      else if (t[1] === 2 || t[1] === -2) c *= E * E;
      sum += c * Math.sin(arg);
    }
    return norm360(Lp + sum / 1000000);
  }

  var SIGNS = [
    { id: 'aries', label: 'Aries', char: '\u2648' }, { id: 'taurus', label: 'Taurus', char: '\u2649' },
    { id: 'gemini', label: 'Gemini', char: '\u264A' }, { id: 'cancer', label: 'Cancer', char: '\u264B' },
    { id: 'leo', label: 'Leo', char: '\u264C' }, { id: 'virgo', label: 'Virgo', char: '\u264D' },
    { id: 'libra', label: 'Libra', char: '\u264E' }, { id: 'scorpio', label: 'Scorpio', char: '\u264F' },
    { id: 'sagittarius', label: 'Sagittarius', char: '\u2650' }, { id: 'capricorn', label: 'Capricorn', char: '\u2651' },
    { id: 'aquarius', label: 'Aquarius', char: '\u2652' }, { id: 'pisces', label: 'Pisces', char: '\u2653' }
  ];

  /* sign(date) -> { id, label, char, lon, degInSign, hoursToChange } */
  function sign(date) {
    var lon = longitude(date), i = Math.floor(lon / 30) % 12;
    var s = SIGNS[i], deg = lon - i * 30;
    /* how long until it crosses: the Moon runs about 13.2 deg a day, refined by a second sample */
    var ahead = new Date(date.getTime() + 3600000);
    var rate = norm360(longitude(ahead) - lon);                 // degrees per hour
    if (rate > 180) rate -= 360;
    var hours = rate > 0.0001 ? (30 - deg) / rate : null;
    return { id: s.id, label: s.label, char: s.char, lon: lon, degInSign: deg, hoursToChange: hours };
  }

  /* The offset a zone is ahead of UTC at a given instant, in ms. */
  function zoneOffset(ms, tz) {
    try {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, year: 'numeric',
        month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      var p = {}, parts = f.formatToParts(new Date(ms));
      for (var i = 0; i < parts.length; i++) p[parts[i].type] = parts[i].value;
      var h = p.hour === '24' ? 0 : +p.hour;
      return Date.UTC(+p.year, +p.month - 1, +p.day, h, +p.minute, +p.second) - ms;
    } catch (e) { return 0; }
  }
  /* "the 14th at 9pm in Santa Barbara" -> the actual instant. Two passes settle DST. */
  function zonedTime(y, mo, d, h, mi, tz) {
    var wall = Date.UTC(y, mo - 1, d, h || 0, mi || 0), ms = wall;
    for (var i = 0; i < 2; i++) ms = wall - zoneOffset(ms, tz);
    return new Date(ms);
  }

  window.COMoon = { age: age, phaseName: phaseName, svg: svg, sentence: sentence,
                    longitude: longitude, sign: sign, SIGNS: SIGNS,
                    zoneOffset: zoneOffset, zonedTime: zonedTime,
                    illumination: illumination, litPath: litPath, SYNODIC: SYNODIC,
                    window: moonWindow, loadWindow: loadWindow };
})();
